import React, { useContext } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import CoinInfoTable from "@features/Wallets/components/WalletList/CoinInfoWallets";
import Typography from "@components/Typography";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { getCurrencyMeta, getIconPath, getIrtMarketKey } from "@core/utils/getCurrencyMeta";
import clsx from "clsx";
import PriceFormat from "@components/PriceFormat";
import { StatsContext } from "@context/statsContext";

const MarketAssests = ({ wallets, className, iconSize = "default" }) => {
  const classes = useStyles();
  const { statsState } = useContext(StatsContext);

  const OverrideTableOption = [
    {
      name: "wallet",
      title: __t("wallet"),
      render: (record, status) => {
        const currentCurrency = getCurrencyMeta(record?.currencyName);
        const CurrencyIcon = currentCurrency.Icon;

        return (
          <div className={classes.coinLogoAndText}>
            {CurrencyIcon ? (
              <CurrencyIcon
                style={{ color: currentCurrency.color }}
                className={classes.coinLogo}
                width={iconSize}
              />
            ) : (
              <img
                src={getIconPath(currentCurrency.code)}
                alt={currentCurrency.code}
                className={classes.coinLogo}
                width={iconSize === "small" ? 16 : 24}
              />
            )}
            <Typography
              isBold
              variant={iconSize === "small" ? "3xs" : "xs"}
              className={classes.currencyName}
              color="secondary.main"
            >
              {currentCurrency.name}
            </Typography>
            <Typography
              variant={iconSize === "small" ? "3xs" : "2xs"}
              color="secondary.tint40"
              className={classes.currencyName}
            >{`(${currentCurrency.unit})`}</Typography>
          </div>
        );
      },
    },

    {
      render: (record, status) => {
        return <PriceFormat price={record.totalBalance} />;
      },
      title: __t("amount"),
    },

    {
      render: (record, status) => {
        return <PriceFormat price={record.blockedBalance} />;
      },
      title: __t("blocked"),
    },

    {
      render: (record, status) => {
        return <PriceFormat price={record.availableBalance} />;
      },

      title: __t("available"),
    },

    {
      render: (record, status) => {
        const irtMarketKey = getIrtMarketKey(record?.currencyName);

        return !!statsState.stats[irtMarketKey]?.unitPrice ? (
          <PriceFormat
            price={
              record?.currencyName === "IRT"
                ? record.availableBalance
                : statsState.stats[irtMarketKey]?.unitPrice *
                  record.totalBalance
            }
          />
        ) : (
          <PriceFormat price={record.availableBalance} />
        );
      },
      title: __t("market value (toman)"),
    },

    {
      render: (record, status) => {
        return (
          <div className={classes.wrapperLastCol}>
            <Tooltip arrow title={__t("deposit")} placement="top-start">
              <div className={classes.inlineBlock}>
                <Link to={`/wallets/${record?.currencyName}/deposit`}>
                  <i className={clsx(classes.plusBtn, "icon-plus")} />
                </Link>
              </div>
            </Tooltip>
            <Tooltip arrow title={__t("request money")} placement="top-start">
              <div className={classes.inlineBlock}>
                <Link to={`/wallets/${record?.currencyName}/withdraw`}>
                  <i
                    className={clsx(
                      classes.cashOutBtn,
                      "icon-cash-out-request"
                    )}
                  />
                </Link>
              </div>
            </Tooltip>
            <div style={{ width: "20px", height: "20px" }}>
              {record?.currencyName !== "IRT" && (
                <Tooltip arrow title={__t("cart")} placement="top-start">
                  <div className={classes.inlineBlock}>
                    <Link to={`/market/${record?.currencyName}-IRT`}>
                      <i className={clsx(classes.bagBtn, "icon-bag")} />
                    </Link>
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        );
      },
      width: "20%",
      // align: "center",
      lastFixed: true,
    },
  ];

  return (
    <CoinInfoTable
      className={className}
      data={wallets}
      pagination={false}
      OverrideTableOption={OverrideTableOption}
      type="sticky"
    />
  );
};

export default MarketAssests;
